<template>
  <div
    id="list_video"
    class="list_video"
  >
    <ul class="short-video-ul">
      <li
        v-for="(item, index) in shortVideo"
        :key="index"
        :data-index="item.idx"
        :ourl="/^\/play/g.test(item.url) ? `https://wapv.sogou.com${item.url}` : item.url"
      >
        <a
          v-if="routeName === 'star' || item.posName || !starVideo || (starVideo && index > 5)"
          :data-report="index"
          data-exposed="false"
          :href="
            (item.resType === 'wechat' || item.resType === 'native')
              && !isSnapShot ? 'javascript:void(0);'
            : item.url
          "
          :ourl="item.itemUrl"
          :uigs="getUigs({ item, index })"
          :uigsparams="getUigsPlayInfo({ item, index })"
          @click="clickOutResult(item, $event)"
        >
          <div class="video-img">
            <span
              v-if="item.showTagName"
              class="collection-tag"
              :style="{ backgroundColor: item.showTagBgColor, color: item.showTagColor }"
            >{{ item.showTagName }}</span>
            <span
              v-if="item.showTagDesc"
              class="collection-desc"
              :class="{ short2long: item.showTagType === 'short2long' }"
            ><i class="icon-collection" /><i class="collection-num">{{ item.showTagDesc }}</i></span>
            <div
              v-else
              class="duration"
            >{{ item.duration }}</div>
            <CoverImage
              :src="item.picurl"
              :is-resize="false"
              :index="index"
            />
          </div>
          <div class="video-detail">
            <h3
              class="short-video-title"
              v-html="item.titleCut"
            />
            <div
              v-if="routeName !== 'star' || (routeName === 'star' && (starTabName === 'video' || !starTab))"
              class="other-info"
            >
              <SiteIcon
                :icon-img="item.siteicon"
                :icon-type="item.iconType"
              />
              <span
                v-if="item.sitename"
                class="other-info-site"
              >
                {{ item.sitename }}
              </span>
              <span
                v-if="item.date"
                class="other-info-date"
              >
                {{ item.date }}
              </span>
            </div>
          </div>
        </a>
        <div
          style="display: none"
          v-html="'<!--v-->'"
        />
        <div
          v-if="$config.debug === 'on' && item.header"
          :class="debugOpen ? 'short-video-debug-info-detail-open' : 'short-video-debug-info-detail'"
          @click="debugOpen = !debugOpen"
        >
          <pre>{{ JSON.stringify(item.header, ' ', 2) }}</pre>
        </div>
      </li>
    </ul>
    <div
      v-if="showLoading"
      class="loading-result"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SiteIcon from '../../common/components/SiteIcon';
import CoverImage from './CoverImage.vue';

export default {
  components: {
    CoverImage,
    SiteIcon,
  },
  props: {
    shortVideo: {
      type: Array,
      default: () => [],
    },
    getUigs: {
      type: Function,
      default: () => null,
    },
    getUigsPlayInfo: {
      type: Function,
      default: () => null,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    searchData: {
      type: Object,
      default: () => {},
    },
    starTab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      debugOpen: false,
      istyle: 'margin-top:10px;margin-bottom:20px',
    };
  },
  computed: {
    ...mapState('common', ['$config', 'loadingFinished']),
    starTabName() {
      return this.$route.query.starTab || this.starTab;
    },
    routeName() {
      return this.$route.name;
    },
    starVideo() {
      return (
        this.searchData
        && this.searchData.type === 'star_summary'
        && this.searchData.entity
        && this.searchData.entity[0].doctype === 'video'
      );
    },
    isSnapShot() {
      return (this.$config || {}).hitSnapshot === '1';
    },
  },
  methods: {
    /**
     * 处理小程序链接点出问题
     */
    clickOutResult(item, $event) {
      const { isSupportNa } = this.$config || {};
      const h5Url = item.playUrl || item.h5Url;
      if (item.resType === 'wechat') {
        $event.preventDefault();
        if (!isSupportNa && h5Url) {
          window.location.href = h5Url;
          return;
        }
        window.location.href = item.url;
      } else if (item.resType === 'native') {
        $event.preventDefault();
        if (!isSupportNa && h5Url) {
          window.location.href = h5Url;
          return;
        }
        const { uuid = '' } = window.UIGS_PARA;
        const timeNow = Date.now();
        const clickSessionId = uuid ? `${uuid}_${timeNow}` : '';
        window.location.href = `${item.url}&clickSessionId=${clickSessionId}&jumpStartTime=${timeNow}`
          + '&useShell=1&preloadShell=1&nafrom=video&bvEnd=90';
      }
    },
    getHintIndex(index) {
      const { starVideo } = this;
      return Math.floor(starVideo ? (index - 6) / 5 : index / 5);
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_search.scss';

.video-list-banner {
  height: 8px;
  background: #f2f2f2;
}

.bottom-banner-adv {
  margin-bottom: 20px;
}
.video-list-banner-bottom {
  margin-top: 10px;
}
.short-video-ul {
  margin: 18px 14px 0;
  li > a {
    padding-bottom: 20px;
    display: flex;
    flex-direction: row;
    .video-img {
      width: 44%;
      padding-top: 24.75%;
      margin-right: 12px;
      overflow: hidden;
      flex-grow: 0;
      flex-shrink: 0;
      position: relative;
      border-radius: 3px;
      box-sizing: border-box;
      min-height: 75px;
      .duration {
        position: absolute;
        right: 4px;
        bottom: 2px;
        font-size: 12px;
        color: #fff;
        line-height: 18px;
        text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.7);
        z-index: 1;
      }
      .collection {
        &-tag {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          padding: 0 6px;
          border-top-left-radius: 3px;
          border-bottom-right-radius: 8px;
          background-color: rgba(0, 0, 0, 0.5);
        }
        &-desc {
          position: absolute;
          bottom: 2px;
          right: 4px;
          z-index: 5;
          min-width: 18px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
          color: #fff;
          text-align: center;

          .icon-collection {
            &:before {
              position: relative;
              top: 2px;
              width: 12px;
              height: 12px;
              display: inline-block;
              content: '';
              background: url('~@asset/img/collection.png');
              background-repeat: no-repeat;
              background-size: 100% auto;
            }
            margin-right: 3px;
          }

          &.short2long {
            .icon-collection {
              display: none;
            }
          }
        }
      }
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        height: 40px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
        border-radius: 3px;
        bottom: 0;
      }
    }
    h3 {
      overflow: hidden;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: block;
      display: -webkit-box;
      font-size: 16px;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
    }
  }
}

.other-info {
  display: flex;
  color: #999;
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
  align-items: center;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &-site {
    font-size: 14px;
    max-width: 5em;
    flex: none;
    margin-right: 8px;
    line-height: 24px;
  }
  &-date {
    font-size: 14px;
    max-width: 6em;
    flex: none;
    line-height: 24px;
  }
  &-tag {
    max-width: 6em;
    height: 17px;
    line-height: 18px;
    padding: 0 5px;
    border-radius: 4px;
    background-color: rgba(254,233,231,1);
    color: #F44837;
    font-size: 11px;
  }
}
.video-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.video-detail-author {
  font-size: 11px;
  line-height: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
  white-space: nowrap;
  margin-top: 3px;
}
.short-video-debug-info-detail {
  height: 100px;
  overflow: scroll;
}
.short-video-debug-info-detail-open {
  overflow-x: scroll;
  height: 100px;
}
</style>
